// Sai Maheshwar 01/12/2022 2701306337 ,2701326866  add intermediate repo field API integration
import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';

const initialState = {
  loading: false,
  errorMsg: '',
  successMsg: '',
  status: '',
  nbFields: null,
};

const slice = createSlice({
  name: 'intermediateRepo',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.errorMsg = '';
      state.successMsg = '';
    },
    fetchError: (state, action) => {
      state.loading = false;
      state.successMsg = '';
      state.errorMsg = action.payload.error;
      state.status = action.payload.status;
    },
    fetchSuccess: (state, action) => {
      state.loading = false;
      state.successMsg = action.payload.message;
      state.errorMsg = '';
      state.status = action.payload.status;
    },
    setNBFieldsData: (state, action) => {
      state.loading = false;
      state.successMsg = '';
      state.errorMsg = '';
      state.nbFields = action.payload;
    },
    resetData: (state) => {
      state.loading = false;
      state.successMsg = '';
      state.errorMsg = '';
      state.status = null;
    },
  },
});
export default slice.reducer;
export const {fetchStart, fetchError, resetData, fetchSuccess, setNBFieldsData} = slice.actions;

export const postNBFields = (payload) => {
  return (dispatch) => {
    httpPost(`nbdatarepofields/save/nbdatarepofields`, payload)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(data));
        } else if (data && data.status === 500) {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getNBFieldNames = (type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`nbdatarepofields/get/nbfields/${type}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(setNBFieldsData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
